var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space"},[_c('div',{staticClass:"tab-list"},[_c('div',{staticClass:"mid"},[_c('span',[_vm._v("个人空间")])])]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"seaech-tab"},[_c('div',{staticClass:"tab-list"},[_c('div',{staticClass:"mid"})])])])])
}]

export { render, staticRenderFns }